// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .pageson {
  background-color: #2d348e;
  color: white;
  width: 2.5rem;
  text-align: center;
  border-radius: 10px
}

.pagesof {
  background-color: white;
  color: black;
  width: 2.5rem;
  text-align: center;
  border-radius: 10px
}

#form1 {
  display: block;
}

#form2 {
  display: none;
}

#form3 {
  display: none;
}

#form {
  display: block;
}

.card-title {
  font-size: x-large;
  font-family: fantasy;
  font-weight: 100;
}

input[type=range],
.range {
  border-radius: 0.75em;
  overflow: hidden;
  margin-bottom: 1.5em;
}

input[type=range] {
  background-color: burlywood;
  box-shadow:
    0.3em 0.3em 0.4em var(--bs2) inset,
    -0.3em -0.3em 0.4em var(--bs1) inset;
  display: block;
  padding: 0 0.1em;
  width: 100%;
  height: 1.5em;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

input[type=range]:focus {
  outline: transparent;
}

input[type=range]::-webkit-slider-thumb {
  background-color: #255ff4;
  border: 0;
  border-radius: 50%;
  box-shadow:
    -0.3em -0.3em 0.5em #0937aa inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
  cursor: pointer;
  position: relative;
  width: 1.3em;
  height: 1.3em;
  transition: all var(--transDur) linear;
  z-index: 1;
  -webkit-appearance: none;
  appearance: none;
}

input[type=range]:focus::-webkit-slider-thumb {
  background-color: #5583f6;
  box-shadow:
    -0.3em -0.3em 0.5em #0b46da inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
}

input[type=range]::-moz-range-thumb {
  background-color: #255ff4;
  border: 0;
  border-radius: 50%;
  box-shadow:
    -0.3em -0.3em 0.5em #0937aa inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
  cursor: pointer;
  position: relative;
  width: 1.3em;
  height: 1.3em;
  transform: translateZ(1px);
  transition: all var(--transDur) linear;
  z-index: 1;
  -moz-appearance: none;
  appearance: none;
}

input[type=range]:focus::-moz-range-thumb {
  background-color: #5583f6;
  box-shadow:
    -0.3em -0.3em 0.5em #0b46da inset,
    0 -0.2em 0.2em 0 #0004,
    0.3em 0.9em 0.8em #0007;
}

input[type=range]::-moz-focus-outer {
  border: 0;
}

.headerstyle {
  background-image: url('http://localhost:7777/LoginImages/reciept.png');
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  height: 67vh;
}

.footerstyle {
  background-image: url('http://localhost:7777/LoginImages/footer.png');
  width: 100vw;
  background-repeat: no-repeat;
  background-size: cover;
  height: 19vh;
}

.hovereffect {
  transition: transform 0.5s, box-shadow 0.5s;
  border-radius: 10px;
  overflow: hidden;
}

.hovereffect:hover {
  transform: scale(1.0);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.281);
}

.card-img-top {
  border-radius: 10px 10px 0 0;
}

.bidder_register_form {
  display: flex;
  width: 70vw;
  justify-content: space-evenly;
  margin-top: 5px;
  font-weight: bold;
}

.download_reciept_button {
  display: flex;
  justify-content: center
}

.searchTender {
  width: 40vw;
  height: 80%;
}

.register-pop {
  background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8));
}

@media screen and (max-width: 768px) {
  .searchTender {
    width: 80vw;
    height: 80%;
  }
}


.loader {
  height: 100px;
  width: 100px;
  border: 12px solid #e3e3e3;
  border-radius: 50%;
  border-right-color: #2673e7;
  animation: spin 1s ease infinite;
}

.Adminloader {
  height: 100px;
  width: 100px;
  margin: auto;
  border: 12px solid #e3e3e3;
  border-radius: 50%;
  border-right-color: #2673e7;
  animation: spin 1s ease infinite;
}

@keyframes spin {
  100%{
    transform: rotate(360deg);
  }
} */


/* --- Vendor Registration Header --- */
.vendor-registration-header {
  background-color: #2d348e;
  color: white;
  padding: 15px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
}

/* --- Vendor Registration Container --- */
.vendor-registration-container {
        margin-left: 18.5rem;
        transition: margin-left 0.3s ease;
        background-color: #efecff;
        min-height: 100vh;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: start;
        padding: 30px;
        box-sizing: border-box;
        overflow-y: auto;

}

/* --- Vendor Registration Card --- */
.vendor-registration-card {
     display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
       max-width: 1130px;
        margin-left: 20px;
          margin-bottom: 40px;
          background-color: #ffffff;
          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          padding: 30px,
}
.inner-form-container
{
            width: "100%";
            max-width: "1200px";
            background-color: "#f3f8ff";
            box-shadow: "0px 4px 10px rgba(0, 0, 0, 0.1)";
            border-radius: "10px";
            padding: "20px",
         
}

/* --- Section Header --- */
.section-header {
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 700;
  color: #001937;
}

/* --- Form Grid --- */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

/* --- Form Group --- */
.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #001937;
}

.form-control {
  padding: 10px;
  border: 1px solid #d0d7de;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-control:focus {
  outline: none;
  border-color: #3b82f6;
}

/* --- Input with Icon --- */
.input-with-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
}

/* --- Form Actions --- */
.form-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}

.btn-submit,
.btn-cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-submit {
  background-color: #39b54a;
  color: white;
  border: none;
}

.btn-submit:hover {
  background-color: #2e8c3a;
}

.btn-cancel {
  background-color: #ee5d50;
  color: white;
  border: none;
}

.btn-cancel:hover {
  background-color: #d94a3e;
}

/* --- Loader --- */
.loader {
  height: 100px;
  width: 100px;
  border: 12px solid #e3e3e3;
  border-radius: 50%;
  border-right-color: #2673e7;
  animation: spin 1s ease infinite;
  margin: auto;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Users/pages/innercss.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6MG;;;AAGH,uCAAuC;AACvC;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;QACQ,oBAAoB;QACpB,iCAAiC;QACjC,yBAAyB;QACzB,iBAAiB;QACjB,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,gBAAgB;;AAExB;;AAEA,qCAAqC;AACrC;KACK,aAAa;UACR,sBAAsB;UACtB,mBAAmB;UACnB,WAAW;OACd,iBAAiB;QAChB,iBAAiB;UACf,mBAAmB;UACnB,yBAAyB;UACzB,2CAA2C;UAC3C,mBAAmB;UACnB;AACV;AACA;;YAEY,aAAa;YACb,mBAAmB;YACnB,2BAA2B;YAC3B,6CAA6C;YAC7C,qBAAqB;YACrB;;AAEZ;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* .pageson {\r\n  background-color: #2d348e;\r\n  color: white;\r\n  width: 2.5rem;\r\n  text-align: center;\r\n  border-radius: 10px\r\n}\r\n\r\n.pagesof {\r\n  background-color: white;\r\n  color: black;\r\n  width: 2.5rem;\r\n  text-align: center;\r\n  border-radius: 10px\r\n}\r\n\r\n#form1 {\r\n  display: block;\r\n}\r\n\r\n#form2 {\r\n  display: none;\r\n}\r\n\r\n#form3 {\r\n  display: none;\r\n}\r\n\r\n#form {\r\n  display: block;\r\n}\r\n\r\n.card-title {\r\n  font-size: x-large;\r\n  font-family: fantasy;\r\n  font-weight: 100;\r\n}\r\n\r\ninput[type=range],\r\n.range {\r\n  border-radius: 0.75em;\r\n  overflow: hidden;\r\n  margin-bottom: 1.5em;\r\n}\r\n\r\ninput[type=range] {\r\n  background-color: burlywood;\r\n  box-shadow:\r\n    0.3em 0.3em 0.4em var(--bs2) inset,\r\n    -0.3em -0.3em 0.4em var(--bs1) inset;\r\n  display: block;\r\n  padding: 0 0.1em;\r\n  width: 100%;\r\n  height: 1.5em;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\ninput[type=range]:focus {\r\n  outline: transparent;\r\n}\r\n\r\ninput[type=range]::-webkit-slider-thumb {\r\n  background-color: #255ff4;\r\n  border: 0;\r\n  border-radius: 50%;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0937aa inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n  cursor: pointer;\r\n  position: relative;\r\n  width: 1.3em;\r\n  height: 1.3em;\r\n  transition: all var(--transDur) linear;\r\n  z-index: 1;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\ninput[type=range]:focus::-webkit-slider-thumb {\r\n  background-color: #5583f6;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0b46da inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n}\r\n\r\ninput[type=range]::-moz-range-thumb {\r\n  background-color: #255ff4;\r\n  border: 0;\r\n  border-radius: 50%;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0937aa inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n  cursor: pointer;\r\n  position: relative;\r\n  width: 1.3em;\r\n  height: 1.3em;\r\n  transform: translateZ(1px);\r\n  transition: all var(--transDur) linear;\r\n  z-index: 1;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n}\r\n\r\ninput[type=range]:focus::-moz-range-thumb {\r\n  background-color: #5583f6;\r\n  box-shadow:\r\n    -0.3em -0.3em 0.5em #0b46da inset,\r\n    0 -0.2em 0.2em 0 #0004,\r\n    0.3em 0.9em 0.8em #0007;\r\n}\r\n\r\ninput[type=range]::-moz-focus-outer {\r\n  border: 0;\r\n}\r\n\r\n.headerstyle {\r\n  background-image: url('http://localhost:7777/LoginImages/reciept.png');\r\n  width: 100vw;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  height: 67vh;\r\n}\r\n\r\n.footerstyle {\r\n  background-image: url('http://localhost:7777/LoginImages/footer.png');\r\n  width: 100vw;\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  height: 19vh;\r\n}\r\n\r\n.hovereffect {\r\n  transition: transform 0.5s, box-shadow 0.5s;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.hovereffect:hover {\r\n  transform: scale(1.0);\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);\r\n  border: 1px solid rgba(0, 0, 0, 0.281);\r\n}\r\n\r\n.card-img-top {\r\n  border-radius: 10px 10px 0 0;\r\n}\r\n\r\n.bidder_register_form {\r\n  display: flex;\r\n  width: 70vw;\r\n  justify-content: space-evenly;\r\n  margin-top: 5px;\r\n  font-weight: bold;\r\n}\r\n\r\n.download_reciept_button {\r\n  display: flex;\r\n  justify-content: center\r\n}\r\n\r\n.searchTender {\r\n  width: 40vw;\r\n  height: 80%;\r\n}\r\n\r\n.register-pop {\r\n  background: linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8));\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .searchTender {\r\n    width: 80vw;\r\n    height: 80%;\r\n  }\r\n}\r\n\r\n\r\n.loader {\r\n  height: 100px;\r\n  width: 100px;\r\n  border: 12px solid #e3e3e3;\r\n  border-radius: 50%;\r\n  border-right-color: #2673e7;\r\n  animation: spin 1s ease infinite;\r\n}\r\n\r\n.Adminloader {\r\n  height: 100px;\r\n  width: 100px;\r\n  margin: auto;\r\n  border: 12px solid #e3e3e3;\r\n  border-radius: 50%;\r\n  border-right-color: #2673e7;\r\n  animation: spin 1s ease infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  100%{\r\n    transform: rotate(360deg);\r\n  }\r\n} */\r\n\r\n\r\n/* --- Vendor Registration Header --- */\r\n.vendor-registration-header {\r\n  background-color: #2d348e;\r\n  color: white;\r\n  padding: 15px 20px;\r\n  border-radius: 12px;\r\n  margin-bottom: 20px;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n\r\n/* --- Vendor Registration Container --- */\r\n.vendor-registration-container {\r\n        margin-left: 18.5rem;\r\n        transition: margin-left 0.3s ease;\r\n        background-color: #efecff;\r\n        min-height: 100vh;\r\n        width: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: start;\r\n        padding: 30px;\r\n        box-sizing: border-box;\r\n        overflow-y: auto;\r\n\r\n}\r\n\r\n/* --- Vendor Registration Card --- */\r\n.vendor-registration-card {\r\n     display: flex;\r\n          flex-direction: column;\r\n          align-items: center;\r\n          width: 100%;\r\n       max-width: 1130px;\r\n        margin-left: 20px;\r\n          margin-bottom: 40px;\r\n          background-color: #ffffff;\r\n          box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n          border-radius: 10px;\r\n          padding: 30px,\r\n}\r\n.inner-form-container\r\n{\r\n            width: \"100%\";\r\n            max-width: \"1200px\";\r\n            background-color: \"#f3f8ff\";\r\n            box-shadow: \"0px 4px 10px rgba(0, 0, 0, 0.1)\";\r\n            border-radius: \"10px\";\r\n            padding: \"20px\",\r\n         \r\n}\r\n\r\n/* --- Section Header --- */\r\n.section-header {\r\n  margin-bottom: 15px;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  color: #001937;\r\n}\r\n\r\n/* --- Form Grid --- */\r\n.form-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n/* --- Form Group --- */\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.form-group label {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  margin-bottom: 6px;\r\n  color: #001937;\r\n}\r\n\r\n.form-control {\r\n  padding: 10px;\r\n  border: 1px solid #d0d7de;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.form-control:focus {\r\n  outline: none;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n/* --- Input with Icon --- */\r\n.input-with-icon {\r\n  position: relative;\r\n}\r\n\r\n.input-icon {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n/* --- Form Actions --- */\r\n.form-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 20px;\r\n  margin-top: 20px;\r\n}\r\n\r\n.btn-submit,\r\n.btn-cancel {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 10px 20px;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.btn-submit {\r\n  background-color: #39b54a;\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n.btn-submit:hover {\r\n  background-color: #2e8c3a;\r\n}\r\n\r\n.btn-cancel {\r\n  background-color: #ee5d50;\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n.btn-cancel:hover {\r\n  background-color: #d94a3e;\r\n}\r\n\r\n/* --- Loader --- */\r\n.loader {\r\n  height: 100px;\r\n  width: 100px;\r\n  border: 12px solid #e3e3e3;\r\n  border-radius: 50%;\r\n  border-right-color: #2673e7;\r\n  animation: spin 1s ease infinite;\r\n  margin: auto;\r\n}\r\n\r\n@keyframes spin {\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
